import Image from 'next/legacy/image';
import styles from './form-submit-status.module.scss';

type FormSubmitStatus = 'success' | 'failure';

interface FormSubmitStatusProps {
  status: FormSubmitStatus;
}

const TITLES = new Map<FormSubmitStatus, string>([
  ['success', 'Application sent'],
  ['failure', 'Application not sent'],
]);

const ICONS = new Map<FormSubmitStatus, string>([
  ['success', '/assets/icons/icn-success.svg'],
  ['failure', '/assets/icons/icn-error.svg'],
]);

const TEXT = new Map<FormSubmitStatus, string>([
  ['success', 'Thank you for leaving a request, we will contact you shortly.'],
  ['failure', 'Unfortunately, something went wrong. Please try again later.'],
]);

export default function FormSubmitStatus({ status }: FormSubmitStatusProps) {
  return (
    <div className={styles.container}>
      <div className={`${styles.icon}  ${status === 'success' ? styles.success : styles.error}`}>
        <Image alt="image" width="32" height="24" src={ICONS.get(status)!} />
      </div>
      <div className={styles.success__title}>{TITLES.get(status)!}</div>
      <div className={styles.success__text}>{TEXT.get(status)!}</div>
    </div>
  );
}
